
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'


export default {
directives: {
TransferDom
},
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
GoTo(item) {
this.$router.push({name: 'NodeSearchOneDetail', params: {item: item, enumtype: this.enumtype}})
},
async first() {
this.currentPage = 1
await this.doQuery()
},
async next() {
this.currentPage--
await this.doQuery()
},
async perv() {
this.currentPage++
await this.doQuery()
},
async doQuery() {
console.log(1)
console.log(this.companynature)
console.log(2)
let param = this.queryParams
try {
this.$vux.loading.show({text: ' 数据载入中'})
param['pageNumber'] = this.currentPage
console.log(param.year)
const queryPromise = await this.$http.get('/API/NodeSearch/GetNodeList'
, {params: param})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
console.log(this.queryResult.Type)
console.log(this.queryParams)
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'
})
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message
})
this.$router.replace({name: 'NodeSearchByDataQuery', params: {code: param.enumtype}})
}
},
async getTableName() {
console.log(this.$route.params)
let no = this.$route.params.enumtype
this.tableindex = no
const queryPromise = await this.$http.get('/API/NodeSeach/NodeNameByNo'
, {params: {no: no}})
console.log(queryPromise)
this.tablename = queryPromise.data.G_NAME
if (no === '9') {
this.tablename = '进出口商品目的地/货源地总值表'
}
}
},
data() {
return {
tableindex: 1,
tablename: '',
keyword: this.$route.params.keyword,
user_name: this.$route.params.user_name,
enumtype: this.$route.params.enumtype,
businessType: this.$route.params.businessType,
nodeName: this.$route.params.nodeName,
node: this.$route.params.node,
post: this.$route.params.post,
secondPost: this.$route.params.secondPost,
firstPost: this.$route.params.firstPost,
business: this.$route.params.business,
queryResult: {Data: [], TotalPage: 0},
currentPage: 1,
queryParams: this.$route.params
}
},
async created() {
await this.getTableName()
this.queryParams = this.$route.params
await this.doQuery()
}
}



// WEBPACK FOOTER //
// ./src/components/NodeSearchByDataDetails.vue